
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import {
  harajukuHawaiianPancakeTopImage,
  harajukuHawaiianPancakeCafeHaleiwaPancakeImage,
  harajukuHawaiianPancakeCafeHaleiwaApperanceImage,
} from "@src/constants/images";
import LazyImage from "@src/components/LazyImage";
import LinkWithThumbnail from "@src/components/LinkWithThumbnail";
import InstaImage from "@src/components/InstaImage";
import { murakamiMasanori } from "@src/constants/authors";
import { meta as rainbowPancakePageMeta } from "./rainbow_pancake.mdx";
export const meta = {
  path: "/media/harajuku/hawaiian_pancake",
  title: "【ハワイ発祥！】原宿・表参道で本場のパンケーキが食べられるお店４選",
  description: "原宿でせっかくパンケーキを食べるなら、**本格的な本場の味**を食べたい。原宿は普段こないからパンケーキに詳しくないし、どこに行けばいいか分からない。行ってみたけどお店が閉店して、記事が最新じゃなかった。そんな悩みはありませんか？今回はパンケーキを日本に流行させた、パンケーキの本場ハワイ発祥のイのパンケーキを原宿で展開している店を厳選してご紹介します！",
  topImg: harajukuHawaiianPancakeTopImage,
  author: murakamiMasanori,
  tags: ["原宿", "行列店", "人気店", "まとめ記事", "スイーツ", "パンケーキ", "インスタ映え"]
};

const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`パンケーキの激戦区の原宿で、パンケーキの本場「ハワイ発祥のパンケーキが食べたい！」という方も多いのではないでしょうか。`}</p>
    <p>{`しかし、激戦区だからこそ閉店しているパンケーキ店もあり、最新の情報を掲載している記事は原宿だと少ないです。
閉店していなかったとしても、どのパンケーキ店がたくさんありすぎて、どこを選べばいいか分からない。`}</p>
    <p>{`そんなあなたに、2020 年最新のパンケーキの本場`}<strong parentName="p">{`ハワイ発祥のパンケーキのお店`}</strong>{`ご紹介させていただきます！`}</p>
    <hr></hr>
    <h2>{`日本にパンケーキを広めた元祖ハワイ発祥のお店： 【Eggs 'n Things（エッグスンシングス）】`}</h2>
    <p>{`一度は聞いたことがあるパンケーキの名店 Eggs 'n Things（エッグスンシングス)！
1974 年にハワイで誕生してから、“All Day Breakfast”を掲げ、ハワイと日本を問わずボリューム感のあるハワイアンパンケーキが食べられます！`}</p>
    <InstaImage postId="B-v71ZDH5Rd" mdxType="InstaImage" />
    <h3>{`そびえ立つパンケーキに実は秘密が！？`}</h3>
    <InstaImage postId="B94DfsXH7yJ" mdxType="InstaImage" />
    <p>{`こんなたくさんのホイップクリームは甘すぎて食べられないのでは！？と思う方もいるのではないでしょうか？
こんなにたくさん入っていても食べられる理由は、`}<strong parentName="p">{`パンケーキの生地にその秘密がある`}</strong>{`そうです！`}</p>
    <p>{`パンケーキの生地に塩が入っているそうで、甘いクリームでもパンケーキがバランスをとってくれて、食べられてしまうらしいです！`}</p>
    <h3>{`1 番人気はメニューはストロベリー、ホイップクリームとマカデミアナッツ！`}</h3>
    <InstaImage postId="B8LhgtnngLM" mdxType="InstaImage" />
    <p>{`甘いクリーム、マカダミアナッツと酸味のあるストロベリーが調和し、それを塩っけのあるパンケーキで締める。何度でも食べれてしまう至極の一品。`}</p>
    <p>{`まだまだ他にもたくさんのメニューがあるので、老舗だからこそ原宿のパンケーキを Eggs 'n Things（エッグスンシングス）で楽しんでみるのはいかがでしょうか！？`}</p>
    {
      /* Todo://お店情報のボックスを入れる */
    }
    <hr></hr>
    <h2>{`日本にふわふわパンケーキを広めたハワイ発祥のお店；【レインボーパンケーキ 】`}</h2>
    <p>{`原宿でトップの地位を確率しているパンケーキの名店が、レインボーパンケーキです！
ハワイをモチーフにしたコンセプトやメニューがたくさん揃えられていますので、ご紹介します！`}</p>
    <h3>{`レインボーの看板が目印！`}</h3>
    <p>{`原宿から徒歩５分歩くと、レインボーの外観が見えます！それがレインボーパンケーキ の目印です！
外観からハワイを感じます！`}</p>
    <InstaImage postId="B4cbRngBO1S" mdxType="InstaImage" />
    <h3>{`レインボーパンケーキの虹が６色の理由`}</h3>
    <p>{`店舗のトレードマークとなっている虹は一般的な７色ではなく６色になっています。
これはハワイの虹が６色で描かれていることからきているそうです！`}</p>
    <InstaImage postId="BlhOfjbgiIn" mdxType="InstaImage" />
    <h3>{`レインボーパンケーキの人気メニューはこちら！`}</h3>
    <h4>{`人気 no.1：マカダミアナッツパンケーキ`}</h4>
    <p>{`ふわっとしたパンケーキに、ナッツとクリームが雪崩落ちるようになっています！`}</p>
    <InstaImage postId="B3PcJdYAOlO" mdxType="InstaImage" />
    <h3>{`その他にもたくさんの人気メニューが！`}</h3>
    <p>{`インスタ映え間違いなしのたくさんの人気メニューがたくさんありますので、
原宿でパンケーキを食べる際には、是非レインボーパンケーキでトライしてみてください。！`}</p>
    <InstaImage postId="B7N1oVyB_ja" mdxType="InstaImage" />
    <InstaImage postId="B89N8hVAARw" mdxType="InstaImage" />
    <p>{`レインボーパンケーキについてさらに詳しくは、下記の記事をご覧ください！`}</p>
    <LinkWithThumbnail meta={rainbowPancakePageMeta} mdxType="LinkWithThumbnail" />
    {
      /* Todo:お店情報を入れる */
    }
    <hr></hr>
    <h2>{`ハワイアンとメキシカンが融合したインスタ映えのお店：Aloha Amigo harajuku`}</h2>
    <h3>{`都会の喧騒から離れた穴場的な場所`}</h3>
    <p>{`名前からハワイの雰囲気を感じるこのお店は、外観からどこか原宿のお店とは異なる雰囲気を感じます。
行列ができて待ちすぎることもないため、原宿でゆっくりハワイのパンケーキが食べたい人にはおすすめのお店になっています！`}</p>
    <InstaImage postId="B4Rkt26lN7k" mdxType="InstaImage" />
    <h3>{`インスタ映え間違いなしの店内`}</h3>
    <p>{`目を引くような壁紙はまさに原宿の他のお店では中々体験できない印象です！`}</p>
    <InstaImage postId="B3rn2PGFGwX" mdxType="InstaImage" />
    <h3>{`フルーツたっぷりのハワイアンなパンケーキが食べられる`}</h3>
    <p>{`南国のハワイといえばフルーツですが、たくさんのフルーツがのったパンケーキが食べられます！`}</p>
    <InstaImage postId="B7OXfEyAgOH" mdxType="InstaImage" />
    <hr></hr>
    <h2>{`ハワイのリゾートを再現した 2020 年開店のお店：パンケーキ&リゾートカフェ HALEIWA`}</h2>
    <p>{`2020 年 3 月にオープンしたばかりのお店なので、まだ知らない人も多いのではないかと思います！
普段とは違ったロールパンケーキなども展開しているお店なので、是非確認してください！`}</p>
    <h3>{`コンセプトはハワイのハレイワ`}</h3>
    <p>{`ハワイのハレイワ地区を再現した中の様子はまさにハワイのリゾートホテルのような空間です！`}</p>
    <LazyImage img={harajukuHawaiianPancakeCafeHaleiwaApperanceImage} alt="ハレイワの外観" mdxType="LazyImage" />
    <h3>{`ロールパンケーキが食べられるお店`}</h3>
    <p>{`ボリュームのあるパンケーキとは少し違ったロールパンケーキが食べられる店になります！
普段のパンケーキとは少し違ったパンケーキを食べてみたい方には必見です！`}</p>
    <LazyImage img={harajukuHawaiianPancakeCafeHaleiwaPancakeImage} alt="ハレイワのパンケーキ" mdxType="LazyImage" />
    <h3>{`まだできたばかりなので待ち時間なしで入れる！？`}</h3>
    <p>{`2020 年 3 月にできたお店なので、これから人気になっていいく前のタイミングなので、行列が並びすぎるということもないです！
普段とは違ったパンケーキが食べたい！ハワイの雰囲気を感じたい方はおすすめのお店に合っています！`}</p>
    <hr></hr>
    <h3>{`おわりに`}</h3>
    <p>{`ハワイのパンケーキ店を厳選してご紹介させていたきましたがいかがでしたでしょうか？
それぞれのお店ごとに特徴があるので、是非ハワイ本場のパンケーキが食べたたくなったときは足を運んでみてください！`}</p>

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;